import React, { Fragment, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import LinearProgress from '@mui/material/LinearProgress';

const ResultDialog = (props) => {
    return (
        <Fragment>
            <Dialog
                open={props.open}
                // scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                maxWidth="xl"
            >
                <DialogTitle id="scroll-dialog-title">{props.title}</DialogTitle>
                <DialogContent dividers={true}>
                    {props.loading && <LinearProgress variant={props.isProgress ? "determinate" : "indeterminate"} value={props.progressValue} />}
                    <Table sx={{ minWidth: 350 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                {props.headers.map(header => (
                                    <TableCell key={header} component="th" scope="row">
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.rows.map(row => (
                                <TableRow key={row.toString()}>
                                    {row.map(cell => (
                                        <TableCell key={cell} align="right">{cell}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    {props.children}
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}


export default ResultDialog;